import { type ResponsiveSources } from './power-cell-getters';
import logger from '~/services/logger';

export type TextComponent =
  | 'h1'
  | 'h2'
  | 'h3'
  | 'h4'
  | 'h5'
  | 'h6'
  | 'p'
  | 'div';

const textComponentMapping: Record<TextComponent, keyof JSX.IntrinsicElements> =
  {
    h1: 'h1',
    h2: 'h2',
    h3: 'h3',
    h4: 'h4',
    h5: 'h5',
    h6: 'h6',
    p: 'p',
    div: 'div',
  };

/**
 * ResponsiveText component - renders the text content for each breakpoint including SEO content
 * @param responsiveText - Text content for each breakpoint
 * @param componentTextLabelTypography - Text component type (h1, h2, h3, h4, h5, h6, p, div)
 * @returns - JSX.Element with responsive text
 */
export function ResponsiveText({
  responsiveText,
  componentTextLabelTypography = 'p',
}: {
  responsiveText: ResponsiveSources;
  componentTextLabelTypography?: TextComponent;
}): JSX.Element {
  try {
    const TextComponent = textComponentMapping[componentTextLabelTypography];

    return (
      <TextComponent>
        <span className="text-component-span-class tablet:!hidden">
          {responsiveText.mobile}
        </span>
        <span className="text-component-span-class mobile:max-tablet:!hidden desktop:!hidden">
          {responsiveText.tablet}
        </span>
        <span className="text-component-span-class mobile:max-desktop:!hidden large-desktop:!hidden">
          {responsiveText.desktop}
        </span>
        <span className="text-component-span-class mobile:max-large-desktop:!hidden">
          {responsiveText['large-desktop']}
        </span>
      </TextComponent>
    );
  } catch (error: any) {
    logger.info(`ResponsiveText: ${error.message}`);
    return <></>;
  }
}
